<h1 class="cdk-visually-hidden">
    {{ assetTitle }} - {{ 'research.portal.fulldisplay.section.filesLinks' | translate }}
</h1>
<esp-arcview-container
    [items]="_filesAndLinks"
    [currentIdx]="(route?.queryParams | async)?.index - 0"
    (currentIdxChange)="handleArcviewIdxChange($event)"
    [assetDetails]="assetDetails"
    [isStandalone]="true"
></esp-arcview-container>
